export default __webpack_public_path__ + "images/ET.7d3c84a.png";